import { render, staticRenderFns } from "./insertSub.vue?vue&type=template&id=5944a1cd&scoped=true"
import script from "./insertSub.vue?vue&type=script&lang=js"
export * from "./insertSub.vue?vue&type=script&lang=js"
import style0 from "./insertSub.vue?vue&type=style&index=0&id=5944a1cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5944a1cd",
  null
  
)

export default component.exports